import React, { useEffect, useState } from "react";
import "./Profile.css";
import BrandImage from "../../assets/images/BrandImage.svg";
import CoverImage from "../../assets/images/Cover.png";
import UserImage from "../../assets/images/UserPic.svg";
import PageImage from "../../assets/images/PageImg.svg";
import WalletIcon from "../../assets/icons/wallet.svg";

import Brand from "../Brand/Brand";
import AdAccountModal from "../AdAccountModal/AdAccountModal";
import UNIVERSAL from "../../config/config";
import LinkFbPage from "../Home/LinkFbPage/LinkFbPage";
import { useDispatch, useSelector } from "react-redux";
import { fbActions } from "../../store/fb-slice";
import { Box, Typography } from "@mui/material";

const Profile = ({ user, userData, setUpdated }) => {
  const [selectedSection, setSelectedSection] = useState("profile");
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [showAdModal, setShowAdModal] = useState(false);
  const [isBrandData, setIsBrandData] = useState(true);
  const [brandData, setBrandData] = useState();
  const [brand, setBrand] = useState(false);
  const [pages, setAllPages] = useState();
  const [tokenInvalid, setTokenInvalid] = useState(false);
  const [_, setIsWhatsAppLinked] = useState("");

  const homePageProfile = useSelector((state) => state.homePageProfile.data);

  const dispatch = useDispatch();

  async function getUserFbPages() {
    return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/facebook/pages", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
      },
      body: JSON.stringify({
        business_id: String(user?.app_business_id),
        next: "",
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log("pages api");
        if (responseJson.data) {
          setAllPages(responseJson.data.fb_pages);
          setTokenInvalid(false);
        } else if (responseJson.error) {
          if (responseJson?.error?.err_code === "TOKEN_INVALID") {
            setTokenInvalid(true);
          } else {
            setTokenInvalid(false);
          }
          // error
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    getUserFbPages();
  }, []);

  useEffect(() => {
    async function getBrandData() {
      return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/info", {
        method: "POST",
        body: JSON.stringify({
          business_id: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson) {
            if (responseJson.data) {
              setBrandData(responseJson.data);
              if (responseJson?.data?.brand_name) {
                setIsBrandData(true);
                dispatch(fbActions.setFbUserId(responseJson?.data?.app_fb_user_id));
              }
            }
            if (responseJson?.data?.brand_name === null || responseJson?.data?.brand_name?.length === 0) {
              setIsBrandData(false);
            }
          } else {
            // error
          }
        })
        .finally(() => {})
        .catch((error) => {
          console.log(error);
        });
    }
    if (!showBrandModal) getBrandData();
  }, [brand, showBrandModal]);

  let colorSuggestions = brandData?.primary_colors ? JSON.parse(brandData?.primary_colors) : [];

  return (
    <>
      {homePageProfile?.fb_link && homePageProfile?.fb_user_token_valid === true ? (
        <div id="profile">
          <h1 className="profile__heading">Account settings</h1>
          <div className="profileContainer">
            <div className="profileContainer__left">
              <ul className="left__sections">
                <a href="#profile" className={selectedSection === "profile" ? "selectedSection" : "section"} onClick={() => setSelectedSection("profile")}>
                  My Profile
                </a>
                <a href="#adAccount" className={selectedSection === "adAccount" ? "selectedSection" : "section"} onClick={() => setSelectedSection("adAccount")}>
                  Social account
                </a>
                <a href="#BrandDetails" className={selectedSection === "BrandDetails" ? "selectedSection" : "section"} onClick={() => setSelectedSection("BrandDetails")}>
                  Brand details
                </a>
              </ul>
            </div>
            <div className="profileContainer__middle"></div>
            <div className="profileContainer__right">
              <div className="rightProfile" id="profile">
                <h1 className="right__heading">My Profile</h1>
                <div className="rightProfile__Container">
                  <img className="rightProfile__ContainerCover-img" src={CoverImage} alt="cover-img" />
                  <div className="rightProfile__ContainerUserInfo">
                    <div className="ContainerUserInfo__Image">
                      <div className="ContainerUserInfo__Img">{user?.business_name?.slice(0, 1)}</div>
                    </div>
                    <div className="ContainerUserInfo__details">
                      <h4>{user.business_name}</h4>
                      <p>{user.email}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rightAccountDetails" id="adAccount">
                <h1 className="right__heading">Wallet</h1>
                <div className="rightAccountDetailsCard rightCardSpaceBetween">
                  <Box display="flex" alignItems="center">
                    <img src={WalletIcon} height={56} width={56} />
                    <Box display="flex" flexDirection="column" marginLeft={3}>
                      <Typography fontSize={18} fontWeight={700} fontFamily="Gilroy">
                        Your wallet balance:
                      </Typography>
                      <Typography fontSize={15} color="#000000b3" fontFamily="Gilroy">
                        You can use this wallet balance for running ads for your business
                      </Typography>
                    </Box>
                  </Box>
                  <div>
                    <Typography fontFamily="Gilroy">
                      ₹<span style={{ fontSize: 24, fontWeight: 600 }}>{userData?.credits}</span>
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="rightBrandDetails" id="adAccount">
                <h1 className="right__heading">Account details</h1>
                <div className={`rightAccountDetailsCard ${userData?.profileUrl && userData?.facebook_page_name ? "rightCardSpaceBetween" : "rightCardCenter"}`}>
                  {userData?.profileUrl && userData?.facebook_page_name && (
                    <div className="rightAccountDetailsCard__second">
                      <p className="rightCardLight">Selected Page</p>
                      <span>
                        <img src={userData?.profileUrl} />
                        <h6 className="rightCardBold">{userData?.facebook_page_name}</h6>
                      </span>
                    </div>
                  )}
                  <div className="rightAccountDetailsCard__third">
                    <button onClick={() => setShowAdModal(true)}>{userData?.profileUrl && userData?.facebook_page_name ? "Change" : "Link Facebook Page"}</button>
                  </div>
                </div>
              </div>
              <div id="BrandDetails" className="rightBrandDetails">
                <div className="right__heading">Brand details</div>
                <div className={`rightBrandDetailsCard ${isBrandData && brandData?.brand_name ? "rightCardSpaceBetween" : "rightCardCenter"}`}>
                  {isBrandData && brandData?.brand_name && (
                    <>
                      <div className="first">
                        <img src={brandData?.brand_logo} alt="brand-logo" />
                      </div>
                      <div className="second">
                        <p className="rightCardLight">Brand name</p>
                        <h6 className="rightCardBold">{brandData?.brand_name}</h6>
                      </div>
                      <div className="third">
                        <p className="rightCardLight">Brand description</p>
                        <h6 className="rightCardBold">{brandData?.brand_description}</h6>
                      </div>
                      <div className="fourth">
                        <p className="rightCardLight">Brand colors</p>
                        <div className="fourthColors">
                          {colorSuggestions &&
                            colorSuggestions?.map((bg, index) => {
                              return <div className="fourthColors__color" style={{ backgroundColor: bg }} id={index}></div>;
                            })}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="fifth">
                    <button onClick={() => setShowBrandModal(true)}>{isBrandData === false ? "Setup" : "Edit"}</button>
                  </div>
                  {showBrandModal && <Brand setShowBrandModal={setShowBrandModal} isBrandData={isBrandData} brandData={brandData} setBrand={setBrand} />}
                  {showAdModal && (
                    <AdAccountModal
                      tokenInvalid={tokenInvalid}
                      getUserFbPages={getUserFbPages}
                      showModal={showAdModal}
                      userData={userData}
                      user={user}
                      pages={pages}
                      setShowAdModal={setShowAdModal}
                      setUpdated={setUpdated}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LinkFbPage setIsWhatsAppLinked={setIsWhatsAppLinked} />
      )}
    </>
  );
};

export default Profile;
